import axios from './axios';
import SETTINGS from '../settings'
export default {
    getHighlightContent(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/highlightcontent`, {params}).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
}